module.exports = __webpack_public_path__ + "img/发展历程.a723c9f0.png";